var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionnaire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 5.83325C11.2867 5.83325 10.1667 4.71325 10.1667 3.33325C10.1667 1.95325 11.2867 0.833252 12.6667 0.833252C14.0467 0.833252 15.1667 1.95325 15.1667 3.33325C15.1667 4.71325 14.0467 5.83325 12.6667 5.83325ZM12.6667 1.83325C11.8401 1.83325 11.1667 2.50659 11.1667 3.33325C11.1667 4.15992 11.8401 4.83325 12.6667 4.83325C13.4934 4.83325 14.1667 4.15992 14.1667 3.33325C14.1667 2.50659 13.4934 1.83325 12.6667 1.83325Z",
    fill: "#475569"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 9.16675H4.66675C4.39341 9.16675 4.16675 8.94008 4.16675 8.66675C4.16675 8.39341 4.39341 8.16675 4.66675 8.16675H8.00008C8.27341 8.16675 8.50008 8.39341 8.50008 8.66675C8.50008 8.94008 8.27341 9.16675 8.00008 9.16675Z",
    fill: "#475569"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 11.8333H4.66675C4.39341 11.8333 4.16675 11.6066 4.16675 11.3333C4.16675 11.0599 4.39341 10.8333 4.66675 10.8333H10.6667C10.9401 10.8333 11.1667 11.0599 11.1667 11.3333C11.1667 11.6066 10.9401 11.8333 10.6667 11.8333Z",
    fill: "#475569"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.1666H6.00004C2.38004 15.1666 0.833374 13.6199 0.833374 9.99992V5.99992C0.833374 2.37992 2.38004 0.833252 6.00004 0.833252H9.33337C9.60671 0.833252 9.83337 1.05992 9.83337 1.33325C9.83337 1.60659 9.60671 1.83325 9.33337 1.83325H6.00004C2.92671 1.83325 1.83337 2.92659 1.83337 5.99992V9.99992C1.83337 13.0733 2.92671 14.1666 6.00004 14.1666H10C13.0734 14.1666 14.1667 13.0733 14.1667 9.99992V6.66659C14.1667 6.39325 14.3934 6.16659 14.6667 6.16659C14.94 6.16659 15.1667 6.39325 15.1667 6.66659V9.99992C15.1667 13.6199 13.62 15.1666 10 15.1666Z",
    fill: "#475569"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaire);
export default __webpack_public_path__ + "static/media/questionnaire.a8021aa5b93db86841710d62a590db88.svg";
export { ForwardRef as ReactComponent };